<template>
  <div class="jInput date-time-container">
    <vue-datetime
      v-model="stringDate"
      :value="value"
      :type="type"
      :title="title"
      :min-datetime="minDatetime"
      :max-datetime="maxDatetime"
      :auto="auto"
      :use12-hour="use12hour"
      :phrases="phrases"
      :hour-step="hourStep"
      :minute-step="minuteStep"
      :placeholder="placeholder"
      :format="format"
      :disabled="disabled"
      :value-zone="'UTC+7'"
      class="jDatetime"
      input-class="jFormGroup form-control"
      @input="$emit('input', $event)"/>
    <label
      v-if="errorRequired"
      class="show">{{ errorMessage }}
    </label>
    <div
      v-show="isFilled && !disabled"
      class="x-container date-time">
      <img
        :src="require('@/assets/icon/xmark.svg')"
        alt="Clear Value"
        @click="clearValue">
    </div>
  </div>
</template>

<script>
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';

let TYPE;
export default {
  components: {
    'vue-datetime': Datetime,
  },
  props: {
    data: {
      type: Number,
      default: null,
    },
    value: {
      type: [String, Object, Number, Array, Boolean, Date],
      default: '',
    },
    type: {
      type: String,
      default: 'date',
    },
    format: {
      type: String,
      default: () => {
        if (TYPE === 'date' || TYPE === undefined || TYPE === '') {
          return 'MMM dd, yyyy';
        }
        if (TYPE === 'time') {
          return 'HH:mm';
        }
        return 'MMM dd, yyyy, HH:mm';
      },
    },
    title: {
      type: String,
      default: () => {
        if (TYPE === 'time') {
          return 'Choose time';
        }
        return '';
      },
    },
    minDatetime: {
      type: String,
      default: null,
    },
    maxDatetime: {
      type: String,
      default: null,
    },
    auto: {
      type: Boolean,
      default: false,
    },
    use12hour: {
      type: Boolean,
      default: false,
    },
    phrases: {
      type: Object,
      default: () => ({ ok: 'Ok', cancel: 'Cancel' }),
    },
    hourStep: {
      type: Number,
      default: 1,
    },
    minuteStep: {
      type: Number,
      default: 1,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isSearch: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: 'Field is required',
    },
    errorRequired: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      stringDate: '',
      timestampDate: null,
    };
  },
  computed: {
    isFilled() {
      return !!this.stringDate;
    },
  },
  watch: {
    stringDate(val) {
      if (val) {
        this.timestampDate = Date.parse(val);
        this.$emit('getTimestamp', this.timestampDate);
      }
    },
    data(val) {
      if (val && typeof val === 'number') {
        this.getStringDate(this.data);
      } else {
        this.stringDate = '';
      }
    },
  },
  beforeCreate() {
    TYPE = this.$options.propsData.type;
  },
  created() {
    if (this.data) {
      this.getStringDate(this.data);
    }
  },
  methods: {
    convertDateTime(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}`;
      }
      return null;
    },
    convertTimestamp(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
        return `${years}-${mounth}-${dates}`;
      }
      return null;
    },
    convertToLocalTime(data) {
      if (data) {
        const dt = new Date(Date.parse(data));
        const localDate = dt;

        const gmt = localDate;
        const min = gmt.getTime() / 1000 / 60; // convert gmt date to minutes
        const localNow = new Date().getTimezoneOffset(); // get the timezone
        const localTime = min + localNow; // get the local time

        const fullDate = new Date(localTime * 1000 * 60);
        const year = fullDate.getFullYear();
        const month = `0${fullDate.getMonth() + 1}`;
        const date = `0${fullDate.getDate()}`;
        const hours = `0${fullDate.getHours()}`;
        const minutes = `0${fullDate.getMinutes()}`;
        const utc = this.isSearch === 'end_date' ? `${year}-${month.substr(-2)}-${date.substr(-2)}T16:59:00.000Z` : `${year}-${month.substr(-2)}-${date.substr(-2)}T${hours.substr(-2)}:${minutes.substr(-2)}:00.000Z`;

        return utc;
      }
      return null;
    },
    getStringDate(data) {
      const date = this.type === 'datetime' ? this.convertDateTime(data) : this.convertTimestamp(data);
      this.stringDate = this.convertToLocalTime(date);
    },
    clearValue() {
      this.stringDate = '';
      this.$emit('getTimestamp', null);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/inputs/jDateTime.vue